module.exports = __webpack_public_path__ + "img/logo_white.9c21156c.png";